class GbTimeline extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.observer = null;
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.staggerSpeed = Number(this.dataset.staggerSpeed) || 125;
    this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));

    if (!this.items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    this.initObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const item = entry.target;
          const index = Number(item.dataset.index) || 0;

          window.setTimeout(() => {
            item.classList.add('is-visible');
          }, index * this.staggerSpeed);

          this.observer.unobserve(item);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.2
      }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }
}

if (!customElements.get('gb-timeline')) {
  customElements.define('gb-timeline', GbTimeline);
}